/**
 * Report Tabs types
 */
export type PanelVariantType = 'REPORTS' | 'FORMATIONS' | 'PREDICTED-LINEUP' | 'PREDICTED-LINEUP-SLIM';

export const REPORTS: PanelVariantType = 'REPORTS';
export const FORMATIONS: PanelVariantType = 'FORMATIONS';
export const PREDICTEDLINEUP: PanelVariantType = 'PREDICTED-LINEUP';
export const PREDICTEDLINEUPSLIM: PanelVariantType = 'PREDICTED-LINEUP-SLIM';

export const PanelVariantTypeList: PanelVariantType[] = [REPORTS, FORMATIONS, PREDICTEDLINEUP, PREDICTEDLINEUPSLIM];
